/**
 * @generated SignedSource<<0c41b1e57e3d9bc0d281c6214cb134bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type YesNoBlank = "blank" | "no" | "yes";
export type YesNoBlankAddressUnknown = "addressUnknown" | "blank" | "no" | "yes";
export type LocationInput = {
  address: string;
  isFirstLocation: YesNoBlank;
  isUnknownRelocationYear: boolean;
  year?: number | null | undefined;
};
export type businessLocationsMutation$variables = {
  bmanTin: string;
  isCompleted: boolean;
  isFirstLocation?: YesNoBlankAddressUnknown | null | undefined;
  locations?: ReadonlyArray<LocationInput> | null | undefined;
  surveyAnswerId: string;
};
export type businessLocationsMutation$data = {
  readonly upsertBusinessAnswer: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type businessLocationsMutation = {
  response: businessLocationsMutation$data;
  variables: businessLocationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCompleted"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFirstLocation"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locations"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surveyAnswerId"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "isCompleted",
        "variableName": "isCompleted"
      },
      {
        "kind": "Variable",
        "name": "isFirstLocation",
        "variableName": "isFirstLocation"
      },
      {
        "kind": "Variable",
        "name": "locations",
        "variableName": "locations"
      },
      {
        "kind": "Variable",
        "name": "surveyAnswerId",
        "variableName": "surveyAnswerId"
      }
    ],
    "concreteType": "RefundUserPutSurveyAnswerOutput",
    "kind": "LinkedField",
    "name": "upsertBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessLocationsMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessLocationsMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "8dd331891b3a136dff4508a0599d7241",
    "id": null,
    "metadata": {},
    "name": "businessLocationsMutation",
    "operationKind": "mutation",
    "text": "mutation businessLocationsMutation(\n  $surveyAnswerId: String!\n  $bmanTin: String!\n  $isCompleted: Boolean!\n  $isFirstLocation: YesNoBlankAddressUnknown\n  $locations: [LocationInput!]\n) {\n  upsertBusinessAnswer(surveyAnswerId: $surveyAnswerId, bmanTin: $bmanTin, isCompleted: $isCompleted, isFirstLocation: $isFirstLocation, locations: $locations) {\n    result\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "226e0e62dd4a227ed437334e9ce2d7c7";

export default node;
